import React, {  } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router';

import Card from '../../../components/Card';
import { distances } from '../../../styles/constants';
import { Table, Thead, Tr, Th, Tbody, Td } from '../../../components/Table';
import { formatDate } from '../../../helpers/formatters';
import { ScheduledCampaigns } from '../helpers';
import { getRemainingTime } from '../../utils/getRemainingTime';
import { StyledTd, StyledTh, StyledTr } from '../common';

interface ScheduledCampaignsListProps {
    campaigns: ScheduledCampaigns[];
}

const ScheduledCampaignsList = (
    {
        campaigns,
    }: ScheduledCampaignsListProps
) => {
    const { t, i18n } = useTranslation();
    const { accountId } = useParams();
    const history = useHistory();

    return (
        <Card
            title={t('marketing.campaign.scheduled')}
            subtitle={t('marketing.campaign.scheduled_campaigns_overview')}
            shortHr
            marginBottom={distances.small}
        >
            <Table>
                <Thead>
                    <Tr>
                        <StyledTh>{t('marketing.campaign.name')}</StyledTh>
                        <Th>{t('marketing.campaign.scheduled')}</Th>
                        <Th>{t('marketing.campaign.created')}</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {campaigns.map((campaign, index) => (
                        <StyledTr
                            key={index}
                            onClick={() => history.push(`/${accountId}/marketing/campaigns/${campaign.id}/edit`)}
                        >
                            <StyledTd>{campaign.name}</StyledTd>
                            <Td>{getRemainingTime(campaign.scheduled, i18n)}</Td>
                            <Td>{formatDate(campaign.createdAt, i18n.language)}</Td>
                        </StyledTr>
                    ))}
                </Tbody>
            </Table>
        </Card>
    );
};

export default ScheduledCampaignsList;
